import Environment from "../Environment/Environment";
import Store from "../Store/Store";
import Rollbar from "../API/Rollbar/Rollbar";

type LogExtras = { [key: string]: any };

function maskPasswords(extras?: LogExtras): LogExtras | undefined {
  if (!extras || typeof extras !== "object") return extras;
  const masked: LogExtras = { ...extras };
  Object.keys(masked).forEach(key => {
    const value = masked[key];
    if (key.toLowerCase().indexOf("pass") !== -1) {
      masked[key] = "******";
      return;
    }
    if (value && typeof value === "object") {
      masked[key] = maskPasswords(value);
    }
  });
  return masked;
}

function userInfo(): string {
  const state: any = Store.getConfigurator().getState();
  const user = state?.app?.session?.user;
  return `user: ${user?.displayName} [id:${user?.id}] (${user?.email}) | agency: ${user?.agency?.displayName} [id:${user?.agency?.id}]`;
}

function buildMessage(message: string, extras?: LogExtras): string {
  const head = userInfo();
  if (!extras || Object.keys(extras).length === 0) return `${head} — ${message}`;
  return `${head} — ${message} — ${JSON.stringify(maskPasswords(extras))}`;
}

class Log {

  public info(message: string, extras?: LogExtras): void {
    if (Environment.isDevelopment()) {
      console.info(`[Log.info] ${message}`, extras || "");
    }
    if (!Rollbar.exists()) return;
    Rollbar.rollbar.info(buildMessage(message, extras));
  }

  public warn(message: string, extras?: LogExtras): void {
    if (Environment.isDevelopment()) {
      console.warn(`[Log.warn] ${message}`, extras || "");
    }
    if (!Rollbar.exists()) return;
    Rollbar.rollbar.warning(buildMessage(message, extras));
  }

  public error(err: any, extras?: LogExtras): void {
    if (Environment.isDevelopment()) {
      console.error("[Log.error]", err, extras || "");
    }
    if (!Rollbar.exists()) return;

    const safeExtras = maskPasswords(extras);
    const message = buildMessage(
      err && err.message ? err.message : "Unhandled error",
      safeExtras,
    );

    if (err instanceof Error) {
      Rollbar.rollbar.error(message, err);
      return;
    }

    Rollbar.rollbar.error(message, safeExtras || err);
  }
}

export default new Log();
